export function redirectTo(to: string) {
  window.location.href = to;
}
